// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { rfqQuoteDetailsQuoteLineCalculatorStyles as rfqQuoteDetailsQuoteLineCalculatorRowStyles } from "@insite/content-library/Widgets/RfqQuoteDetails/RfqQuoteDetailsQuoteLineCalculatorRow";
import Checkmark from "@rugby/XDL/Icons/Checkmark";
import Close from "@rugby/XDL/Icons/Close";
import { css } from "styled-components";

rfqQuoteDetailsQuoteLineCalculatorRowStyles.calculatorCell = {
    ...rfqQuoteDetailsQuoteLineCalculatorRowStyles.calculatorCell,
    css: css`
        ${rfqQuoteDetailsQuoteLineCalculatorRowStyles.calculatorCell?.css}
        margin-top: 20px;
    `,
};

rfqQuoteDetailsQuoteLineCalculatorRowStyles.priceBreakWithCalculatorRow = {
    ...rfqQuoteDetailsQuoteLineCalculatorRowStyles.priceBreakWithCalculatorRow,
    css: css`
        ${rfqQuoteDetailsQuoteLineCalculatorRowStyles.priceBreakWithCalculatorRow?.css}
        td:first-child {
            background: none;
        }
    `,
};

rfqQuoteDetailsQuoteLineCalculatorRowStyles.priceBreakRow = {
    ...rfqQuoteDetailsQuoteLineCalculatorRowStyles.priceBreakRow,
    css: css`
        ${rfqQuoteDetailsQuoteLineCalculatorRowStyles.priceBreakRow?.css}
        td:first-child {
            background: none;
        }
    `,
};

rfqQuoteDetailsQuoteLineCalculatorRowStyles.percentGridItem = {
    ...rfqQuoteDetailsQuoteLineCalculatorRowStyles.percentGridItem,
    css: css`
        ${rfqQuoteDetailsQuoteLineCalculatorRowStyles.percentGridItem?.css}
        &&& {
            flex-basis: auto;
        }
    `,
};

rfqQuoteDetailsQuoteLineCalculatorRowStyles.buttonsGridItem = {
    ...rfqQuoteDetailsQuoteLineCalculatorRowStyles.buttonsGridItem,
    css: css`
        ${rfqQuoteDetailsQuoteLineCalculatorRowStyles.buttonsGridItem?.css}
        justify-content: flex-start;
        padding-left: 16px;
    `,
};

rfqQuoteDetailsQuoteLineCalculatorRowStyles.applyDiscountIcon = {
    src: Checkmark,
    size: 16,
};

rfqQuoteDetailsQuoteLineCalculatorRowStyles.percentIcon = {
    ...rfqQuoteDetailsQuoteLineCalculatorRowStyles.percentIcon,
    size: 18,
};

rfqQuoteDetailsQuoteLineCalculatorRowStyles.removePriceBreakIcon = {
    src: Close,
    size: 12,
};
